import { COMPLIANCE_QUESTIONS } from '@funnels/constants';
import { Question } from '@funnels/types';

export function getPPSComplianceDisplayFields(questions: Question[]) {
  const hasCustomerDiscussionSummary = questions.some(
    (q: Question) => q === COMPLIANCE_QUESTIONS.CUSTOMER_DISCUSSION_SUMMARY
  );
  const hasRequirementAndObjectSummary = questions.some(
    (q: Question) => q === COMPLIANCE_QUESTIONS.REQUIREMENTS_AND_OBJECTIVES_SUMMARY
  );
  const hasAllApplicantsUnderstandEnglish = questions.some(
    (q: Question) => q === COMPLIANCE_QUESTIONS.UNDERSTAND_ENGLISH
  );
  const hasInterviewLocation = questions.some((q: Question) => q === COMPLIANCE_QUESTIONS.INTERVIEW_LOCATION);
  const hasAllApplicantPresent = questions.some((q: Question) => q === COMPLIANCE_QUESTIONS.INTERVIEWED_IN_PERSON);
  const hasAgreementOfUnderstanding = questions.some(
    (q: Question) => q === COMPLIANCE_QUESTIONS.AGREEMENT_OF_UNDERSTANDING
  );

  return {
    hasCustomerDiscussionSummary,
    hasRequirementAndObjectSummary,
    hasAllApplicantsUnderstandEnglish,
    hasInterviewLocation,
    hasAllApplicantPresent,
    hasAgreementOfUnderstanding,
  };
}
